import { Empty, Table } from 'antd';
import { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import { usePagination } from '@/hooks/use-pagination';
import { useUserInfoStore } from '@/store';

import { useGetServices } from '../api/use-get-services';
import { useServicesTable } from '../hooks/use-services-table';

type Props = {
  contractNumber: string;
  dateRange: [Dayjs | null, Dayjs | null] | null;
};

const ServicesTable = ({ contractNumber, dateRange }: Props) => {
  const { t } = useTranslation('serviceHistoryPage');
  const { selectedAccount } = useUserInfoStore();
  const { page, pageSize, setPageSize, setPage } = usePagination();
  const { columns } = useServicesTable();

  const servicesQuery = useGetServices({
    params: {
      page,
      pageSize,
      sideloading: ['object', 'itemType', 'contract', 'garbage', 'price', 'objectAddress'],
      ownerCodes: [selectedAccount?.code],
      ...(dateRange?.[0] && { startDate: dateRange[0].toISOString() }),
      ...(dateRange?.[1] && { endDate: dateRange[1].toISOString() }),
      contractNumbers: contractNumber ? [contractNumber] : undefined,
    },
    queryConfig: {
      enabled: !!selectedAccount?.code,
    },
  });

  return (
    <Table
      rowKey={(record) => record.id.toString()}
      className="w-full"
      loading={servicesQuery.isLoading}
      locale={{
        emptyText: <Empty description={t('noData', { ns: 'table' })} />,
      }}
      scroll={{ x: 'max-content' }}
      columns={columns}
      dataSource={servicesQuery?.data?.data || []}
      pagination={{
        defaultCurrent: page,
        hideOnSinglePage: true,
        pageSizeOptions: [10, 20, 50, 100],
        total: servicesQuery.data?.meta?.totalItems,
        position: ['bottomRight'],
        onChange: setPage,
        onShowSizeChange: (_, size) => setPageSize(size),
        defaultPageSize: pageSize,
      }}
    />
  );
};

export default ServicesTable;
